import React from 'react'
import styled from '@emotion/styled'
require('prismjs/themes/prism.css')

const Body = styled.div`
  margin: 0 0 auto;
  flex: 1 0 auto;
  max-width: ${props => props.theme.sizes.maxWidthCentered};
  h1,
  h2,
  h3 {
    // font-weight: 600;
    // line-height: 1.25;
    margin: 0 0 0.6rem 0;
    // text-transform: capitalize;
    font-family: ${props => props.theme.fonts.title};
  }

  h1 {
    font-size: 1.75em;
  }
  h2 {
    font-size: 1.5em;
  }
  h3 {
    font-size: 1.25em;
  }

  p {
    margin: 0 0 1em 0;
  }

  a {
    transition: 0.2s;
    color: ${props => props.theme.colors.text};
  }

  del {
    text-decoration: line-through;
  }
  strong {
    font-weight: 600;
  }
  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 0 0 1em 0;
  }

  p + ul,
  p + ol {
    margin-top: -1em;
  }

  ul {
    li {
      list-style: disc;
      list-style-position: inside;
      &:last-child {
        margin: 0;
      }
    }
  }

  ol {
    li {
      list-style: decimal;
      list-style-position: inside;
      &:last-child {
        margin: 0;
      }
    }
  }

  hr {
    border-style: solid;
    border-color: ${props => props.theme.colors.secondary};
    width: 50%;
    margin: 3rem auto;
  }

  blockquote {
    // font-style: italic;
    border-left: 4px solid ${props => props.theme.colors.secondary};
    padding: 0 0 0 0.5em;

  }

  pre {
    margin: 0 0 2em 0;
    border-radius: 2px;
    background: ${props => props.theme.colors.secondary} !important;
    span {
      background: inherit !important;
    }
  }
`

const PageBody = props => {
  return (
    <Body
      dangerouslySetInnerHTML={{ __html: props.body.childMarkdownRemark.html }}
    />
  )
}

export default PageBody
